import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

interface IMenuItemProps {
  title: string;
  active?: boolean;
  href: string;
}

const SubMenuItem: FC<IMenuItemProps> = ({ title, href, active = false }) => {
  const navigate = useNavigate();

  return (
    <a
      // href={href}
      onClick={() => {
        navigate(href);
      }}
      className={`relative cursor-pointer font-normal leading-[17px] ${active ? 'text-[white] rounded-[8px]' : 'text-[#959595]'}`}
    >
      <div className={`${active ? 'bg-[#201F24] p-[8px]  rounded-[8px]' : 'p-[8px]'}`}>{title}</div>
    </a>
  );
};

export default SubMenuItem;
